import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { useTranslation } from 'react-i18next'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Wrapper from '../../components/Wrapper'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import Spacer from '../../uielements/Spacer'
import InnerTitle from '../../uielements/InnerTitle'
import Level from './level'

const EduLevelsWrapper = styled.div`
    .slick-prev {
        right: 60px;
        left: unset;
        top: -10px;
        transform: translateY(-100%);
        z-index: 9;
        width: 40px;
        height: 40px;
    }

    .slick-next {
        right: 15px;
        transform: translateY(-100%);
        top: -10px;
        z-index: 9;
        width: 40px;
        height: 40px;
    }

    .slick-prev:before,
    .slick-next:before {
        font-size: 40px;
        color: #21acff;
    }
`

const EduLevels = () => {
    const { i18n } = useTranslation()

    const settings = {
        dots: true,
        slidesToScroll: 1,
        className: 'center',
        centerMode: true,
        infinite: true,
        padding: 300,
        slidesToShow: 2,
        speed: 500,
        arrows: true,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    dots: true,
                    arrows: true,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: true,
                    dots: true,
                    arrows: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    }

    const eduLevels = useStaticQuery(
        graphql`
            query FetchAllEducationalLevels {
                allContentfulEducationalLevels(sort: {order: ASC}) {
                    nodes {
                        id
                        title
                        slug
                        node_locale
                        featuredImage {
                            title
                            description
                            url
                            gatsbyImageData(
                                placeholder: BLURRED
                                height: 1920
                                width: 1920
                                quality: 75
                                sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                                layout: FULL_WIDTH
                                breakpoints: [576, 768, 960, 1200, 1920]
                            )
                        }
                    }
                }
            }
        `
    )

    const items = eduLevels.allContentfulEducationalLevels.nodes

    return (
        <div id={'eduLevels'}>
            <Wrapper>
                <InnerTitle title="ΕΚΠΑΙΔΕΥΤΙΚΕΣ ΒΑΘΜΙΔΕΣ" mainColor={theme.blue} secColor={theme.lightBlue} />
            </Wrapper>
            <Spacer top="10" />
            <EduLevelsWrapper>
                <Slider {...settings}>
                    {items.map(
                        (item) =>
                            item.node_locale === i18n.language && (
                                <Level
                                    key={item.id}
                                    excerpt={item?.excerpt}
                                    slug={item.slug}
                                    bgImage={item?.featuredImage?.url}
                                >
                                    {item.title}
                                </Level>
                            )
                    )}
                </Slider>
            </EduLevelsWrapper>
        </div>
    )
}

export default EduLevels
